<template>
  <footer id="footer">
    <div class="container">
      <div class="footer-container">
        <div class="footer-top">
          <ul class="footer-links">
            <li><router-link to="/general-principle" target="_blank">{{ $t('general_policy') }}</router-link></li>
            <li><router-link to="/privacy-policy" target="_blank">{{ $t('privacy_policy') }}</router-link></li>
            <li><router-link to="/delivery-policy" target="_blank">{{ $t('delivery_policy') }}</router-link></li>
            <li><router-link to="/refund-policy" target="_blank">{{ $t('refund_policy') }}</router-link></li>
          </ul>
          <ul class="btn__social">
            <li>
              <a @click="handleGACustomEvent('ITC_W_1005')" href="https://www.facebook.com/ismart.ecosystem"
                target="_blank">
                <img src="/themes/ito/images/social-fb.svg" alt="">
              </a>
            </li>
            <li>
              <a @click="handleGACustomEvent('ITC_W_1006')" href="https://www.youtube.com/user/DigiClassVietnam"
                target="_blank">
                <img src="/themes/ito/images/social-ytb.svg" alt="" class="icon-ytb">
              </a>
            </li>
            <li>
              <a @click="handleGACustomEvent('ITC_W_1007')" href="https://twitter.com/iSMARTEducatio1" target="_blank">
                <img src="/themes/ito/images/social-instagram.svg" alt="">
              </a>
            </li>
            <li>
              <a href="http://online.gov.vn/Home/WebDetails/83151" target="_blank">
                <img src="/themes/ito/images/icons/bo-cong-thuong.png" alt="">
              </a>
            </li>
          </ul>
        </div>
        <div class="copy-right-txt" v-html="$t('copy_right')"></div>
      </div>
    </div>
  </footer>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
import { getMenus } from '../models/menu'
import $ from 'jquery'

export default {
  name: "FooterElement",

  data() {
    return {
      // user: this.$store.getters.user_info,
      menus: [],
      user: {
        name: '',
        fullname: 'Guest',
      }
    };
  },

  computed: {
    ...mapGetters([
      'user_info'
    ], () => {
      if (this.user_info) {
        return this.user_info
      }

      return this.user
    })
  },

  created() {
    this.fetch();
  },

  updated: function () {
    this.$nextTick(function () {
      App.init();
    })
  },

  methods: {
    fetch() {

    },
    handleGACustomEvent(element) {
      const user_id = this.user_info.user_id || 0;
      var params = {
        'w_user_id': user_id
      }
      params[element] = user_id
      gtag('event', element, params)
    }

  }
}
</script>

<style scoped>
.footer-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
}

.footer-links {
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 24px;
}

.footer-links a {
  color: var(--primary);
  text-decoration: none;
  font-family: Nunito;
  font-weight: 700;
  font-size: 11px;
  line-height: 100%;
  letter-spacing: 0px;
}

.footer-links a:hover {
  text-decoration: underline;
}

.btn__social {
  margin: 0;
  padding: 0;
  display: flex;
  align-items: center;
  gap: 21px;
}

.btn__social li {
    list-style: none;
    display: flex;
    justify-content: center;
    align-items: center;
}

.btn__social img {
  height: 24px;
  width: auto;
}

.btn__social img.icon-ytb {
  height: auto;
  width: 24px;
}
</style>
